import { render, staticRenderFns } from "./ll1.vue?vue&type=template&id=60cc2848&"
import script from "./ll1.vue?vue&type=script&lang=js&"
export * from "./ll1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports